import request from './request';

export const professorApi = {
    // 获取教授列表
    getProfessors(params) {
        return request.get('/professors', { params });
    },

    // 获取单个教授详情
    getProfessor(id) {
        return request.get(`/professors/${id}`);
    },

    // 创建教授
    createProfessor(data) {
        return request.post('/professors', data);
    },

    // 更新教授信息
    updateProfessor(id, data) {
        return request.put(`/professors/${id}`, data);
    }
};

// 创建新学校
export const createSchool = (data) => {
    return request({
        url: '/api/schools',
        method: 'post',
        data
    });
};

// 创建新院系
export const createDepartment = (data) => {
    return request({
        url: '/api/departments',
        method: 'post',
        data
    });
};

// 创建新教授
export const createProfessor = (data) => {
    return request({
        url: '/api/professors',
        method: 'post',
        data
    });
}; 